import { Module } from '@plugins/modular'
import Routes from './organization-routes'
import configs from './config'

class OrganizationModule extends Module {
  /**
   * @constructor
   * @param {[key: string]: string} config
   */
  constructor(config = configs) {
    /** string name this name is used to get module from module manager */
    super(config.name, config)
    this.translationKey = config.translationKey || name
  }
  routes = Routes
}

export default OrganizationModule
